

export default function GenericCell({ text, colour = "gray", title = "" }: { text: string, colour?: string, title?: string }) {

  const classes = `rounded-full px-3 py-1 text-xs font-semibold bg-${colour}-100 text-${colour}-800`;

  return (
    <div title={title} className="flex justify-center items-center flex-1 text-nowrap">
      <span>
        <span className={classes}>{text}</span>
      </span>
    </div>
  )
}